import parser from 'ua-parser-js'

import VenderContent from 'components/pages/Vender/VenderContent'
import MetaTags from 'components/pages/Vender/VenderContent/MetaTags'
import NoindexRemoval from 'components/common/NoindexRemoval'
import withLivingSinyi from 'utils/withLivingSinyi'
import { hasVenderAboutContent } from 'utils/helpers'
import {
  getAlbumCount,
  getArticleCount,
  getVenderById,
  getVenderByUrlId,
} from 'utils/api'

const VenderAboutPage = (props) => (
  <>
    <NoindexRemoval />
    <MetaTags
      resolvedUrl={props.resolvedUrl}
      vender={props.fallbackData?.vender}
      pageType="about"
    />
    <VenderContent {...props} />
  </>
)

const buildVenderPath = (urlId, query = {}, suffix = '') => {
  const searchParams = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (key === 'venderUrlId' || value == null) return

    const values = Array.isArray(value) ? value : [value]
    values.forEach((item) => searchParams.append(key, item))
  })

  const queryString = searchParams.toString()
  return `/vender/${urlId}${suffix}${queryString ? `?${queryString}` : ''}`
}

const redirectToVenderList = {
  redirect: {
    destination: '/vender?page=1',
    permanent: true,
  },
}

export const getServerSideProps = async (context) => {
  const ua = parser(context.req.headers['user-agent'])
  const isMobile = ['mobile', 'tablet'].includes(ua.device.type)
  const requestedUrlId = context.params.venderUrlId
  const [venderByUrlId] = await getVenderByUrlId(requestedUrlId)

  if (venderByUrlId && venderByUrlId.urlId !== requestedUrlId) {
    return {
      redirect: {
        destination: buildVenderPath(
          venderByUrlId.urlId,
          context.query,
          '/about'
        ),
        permanent: true,
      },
    }
  }

  if (venderByUrlId && !venderByUrlId?.introductionInfo?.isVisible) {
    return redirectToVenderList
  }

  if (!venderByUrlId) {
    const [venderById, errorById] = await getVenderById(requestedUrlId)

    if (errorById || !venderById || !venderById?.introductionInfo?.isVisible) {
      return redirectToVenderList
    }

    return {
      redirect: {
        destination: buildVenderPath(venderById.urlId, context.query, '/about'),
        permanent: false,
      },
    }
  }

  const aboutData = venderByUrlId?.companyIntroSetting

  if (!hasVenderAboutContent(aboutData)) {
    return {
      redirect: {
        destination: buildVenderPath(venderByUrlId.urlId),
        permanent: false,
      },
    }
  }

  const [albumCountResult, articleCountResult] = await Promise.all([
    getAlbumCount({ venderId: venderByUrlId._id }),
    getArticleCount({ venderId: venderByUrlId._id }),
  ])
  const [albumCount = 0] = albumCountResult
  const [articleCount = 0] = articleCountResult

  return {
    props: {
      fallbackData: {
        venderUrlId: venderByUrlId.urlId,
        vender: venderByUrlId,
        albumCount: albumCount || 0,
        articleCount: articleCount || 0,
      },
      isMobile,
      pageType: 'about',
      resolvedUrl: context.resolvedUrl,
    },
  }
}

export default withLivingSinyi(VenderAboutPage)
